import _ from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { Form } from "semantic-ui-react";
import { PdApiActions, pdApiActions } from "../../../actions/pdApiActions";
import DropdownField from "../../../components/Editing/DropdownField";
import {
  getDomainOptions,
  getItemTypeOptions,
  getDomainGroupOptions
} from "../../../utils/pdApiUtils";

type StateProps = {
  filterOptions: State.TranslationStatusFilterOptions;
  pdApi: State.PdApi;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
};
type OwnProps = {
  filterTarget: string;
  onChange: (options: State.TranslationStatusFilterOptions) => void;
};

export type TranslationStatusFilterProps = StateProps & DispatchProps & OwnProps;

export class TranslationStatusFilter extends React.Component<TranslationStatusFilterProps> {
  render(): JSX.Element {
    const { pdApi, filterOptions, filterTarget, onChange } = this.props;
    const { domainGroups } = pdApi;

    const domainGroupOptions =
      filterTarget === "domainGroup" ? getDomainGroupOptions(domainGroups) : [];
    const itemTypeOptions =
      filterTarget === "itemType"
        ? getItemTypeOptions(filterOptions.selectedDomainGroupEnumValue)
        : [];

    const selectedDomainGroupId = _.values(domainGroups).find(
      domainGroup => domainGroup.enumValue === filterOptions.selectedDomainGroupEnumValue
    )?.id;

    const domainOptions =
      filterTarget === "domain" ? getDomainOptions(pdApi.domains, selectedDomainGroupId) : [];

    return (
      <Form className="filterForm">
        {filterTarget === "domainGroup" && (
          <DropdownField
            id="domainGroupFilter"
            label="Domain group"
            value={filterOptions.selectedDomainGroupEnumValue}
            options={domainGroupOptions}
            onChange={enumValue => {
              this.props.pdApiActions.setTranslationStatusFilterOptions({
                ...filterOptions,
                selectedDomainGroupEnumValue: enumValue,
                selectedDomainEnumValue: -1,
                selectedItemTypeId: 0
              });
              onChange({
                ...filterOptions,
                selectedDomainGroupEnumValue: enumValue,
                selectedDomainEnumValue: -1,
                selectedItemTypeId: 0
              });
            }}
          />
        )}
        {filterTarget === "domain" && (
          <DropdownField
            id="domainFilter"
            label="Domain"
            value={filterOptions.selectedDomainEnumValue}
            options={domainOptions}
            onChange={enumValue => {
              this.props.pdApiActions.setTranslationStatusFilterOptions({
                ...filterOptions,
                selectedDomainEnumValue: enumValue
              });
              onChange({ ...filterOptions, selectedDomainEnumValue: enumValue });
            }}
          />
        )}
        {filterTarget === "itemType" && (
          <DropdownField
            id="itemTypeFilter"
            label="Item type"
            value={filterOptions.selectedItemTypeId}
            options={itemTypeOptions}
            onChange={id => {
              this.props.pdApiActions.setTranslationStatusFilterOptions({
                ...filterOptions,
                selectedItemTypeId: id
              });
              onChange({ ...filterOptions, selectedItemTypeId: id });
            }}
          />
        )}
      </Form>
    );
  }
}

const mapStateToProps = (state: State.Root) => ({
  filterOptions: state.translationStatusFilterOptions,
  pdApi: state.pdApi
});

const mapDispatchToProps = (dispatch: Dispatch<PdApiActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TranslationStatusFilter);
